import axios from "axios";
import { AirCarriersResponseDTO } from "./response.types";
import { injectApiKeyHeader, injectDataInterceptor, injectSearchCustomHeader } from "shared/api/utils/api.utils";

const AIR_CARRIERS_API_URL = "https://api.qubictron.com/tracking/v1/air/carriers";

const airCarriersRequestInstance = axios.create();
airCarriersRequestInstance.defaults.baseURL = AIR_CARRIERS_API_URL;
injectApiKeyHeader(airCarriersRequestInstance);
injectSearchCustomHeader(airCarriersRequestInstance);
injectDataInterceptor(airCarriersRequestInstance);

class AirCarriersApi {
  public getAirCarriers() {
    return airCarriersRequestInstance.get<AirCarriersResponseDTO, AirCarriersResponseDTO>("");
  }
}

export const airCarriersService = new AirCarriersApi();
